<div class="staffer">
  <i class="fa fa-times" (click)="dismissPopup()"></i>
  <div *ngIf="!isLoading" class="ion-text-center child detail">
    <div class="img-container">
      <div>
        <img *ngIf="data.imgURL" src="{{ data.imgURL }}" />
      </div>
      <div class="heading">
        <p class="ov-auto para">Well done!</p>
      </div>
    </div>

    <div class="description">
      <ng-container *ngIf="data.message === 'auto_approved'; else pendingReview">
        <p class="ov-auto para">
          Your profile has been approved!
          <span class="mont-bold" style="font-family: Mont-Bold !important">
            You can now browse and apply for available shifts.
          </span>
        </p>
      </ng-container>
      <ng-template #pendingReview>
        <p class="ov-auto para">
          We have received your application and our team is reviewing it,
          <span class = "mont-bold" style="font-family: Mont-Bold !important">
            You will receive an approval
            {{ isIdVerificationStatusPending ? 'confirmation' : 'email' }}
            soon.
          </span>
        </p>
        <br>
        <p class="ov-auto para" *ngIf="isIdVerificationStatusPending">
          In the meantime we will send you an email with instructions to verify your identity, please complete them as soon as possible.
        </p>
      </ng-template>
    </div>

    <div class="buttons-section">
      <ion-button
        *ngIf="isIdVerificationStatusPending"
        color="basic"
        id="success-popup-btn"
        class="ion-no-margin btn success-popup-ok"
        (click)="requestIdVerification()"
      >
        Start ID verification
      </ion-button>
      <ion-button
        *ngIf="!isIdVerificationStatusPending"
        color="basic"
        id="success-popup-btn"
        class="ion-no-margin btn success-popup-ok"
        (click)="navigateToHome()"
      >
        {{data.btn}}
      </ion-button>
    </div>
  </div>
  <div class="spinner" *ngIf="isLoading">
    <ion-spinner></ion-spinner>
  </div>
</div>